import classNames from 'classnames';
import React from 'react';
import { EngagementPlanTask } from '@redux/tasks/tasksTypes';
import { FREQUENCY_SELECT_OPTIONS, FrequencySelectOptions } from 'components/FrequencySelectBlock/FrequencySelectBlock';
import { RepeatIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { getShortTimeString } from 'utils/time';
import style from './PlanTaskDescriptionString.scss';

type Props = {
  task: EngagementPlanTask;
  duration?: number;
  containerStyle?: string;
};

export const PlanTaskDescriptionString: React.FC<Props> = ({ task, duration, containerStyle }) => {
  const totalTasks = task.frequencyType === FREQUENCY_SELECT_OPTIONS.no_repeat ? 1 : duration || 0;

  return (
    <div className={classNames(style.description, containerStyle)}>
      <Text variant="sm" color={Color.GRAY}>
        {task.taskType}&nbsp;·&nbsp;
      </Text>
      {task.frequencyType !== FREQUENCY_SELECT_OPTIONS.no_repeat && <RepeatIcon width={16} height={16} color={Color.GRAY} />}
      <Text variant="sm" color={Color.GRAY}>
        {FrequencySelectOptions[task.frequencyType]}
        {task.frequencyType !== FREQUENCY_SELECT_OPTIONS.no_repeat ? ` at ${getShortTimeString(task.deliveryStartTime)}` : ''}
        {!!duration && !!totalTasks && ` (${totalTasks} total task${totalTasks === 1 ? '' : 's'})`}
      </Text>
    </div>
  );
};
